module.exports = __webpack_public_path__ + "static/abdul-eefb29f7338df35c2a86ea6da8bfda1c.jpg";